import { useEffect, useState } from 'react';

import { useSessionStore } from '@/entities/session';
import { EVENT, openLink, track, trackView, VIEW } from '@/shared/lib';
import { RADIUS, Squircle } from '@/shared/ui';

import styles from './SubscribeModal.module.scss';

/**
 * Напоминание подписаться на канал (узел 438:50563/438:50861).
 *
 * Триггер — `user.isSubscribed === false`, а не разовый флаг вроде
 * `isNewUser` у WelcomeModal: подписка может пропасть в любой момент,
 * поэтому предупреждение обязано появляться заново на каждом заходе,
 * пока её нет, а не только один раз за сессию.
 *
 * Кнопка ведёт на канал: ссылку собирает сервер из `game_setting`
 * и отдаёт в профиле. Канал не настроен — `channelUrl` пуст, и кнопки
 * нет вовсе: вести игрока в никуда хуже, чем не звать.
 */
export function SubscribeModal() {
  const isSubscribed = useSessionStore((state) => state.user?.isSubscribed);
  const channelUrl = useSessionStore((state) => state.user?.channelUrl ?? null);
  const [dismissed, setDismissed] = useState(false);

  // ТЗ просит и «количество выдачи экранов Подпишись на канал»,
  // и уникальные клики по нему. Выдача считается НЕуникально — значит
  // просмотр; клик уникально за визит — значит цель. В Метрике это
  // разные механизмы, и подменить один другим — посчитать не тот
  // показатель
  const shown = isSubscribed === false && !dismissed;
  useEffect(() => {
    if (shown) trackView(VIEW.subscribeScreen);
  }, [shown]);

  if (!shown) return null;

  const close = (): void => {
    setDismissed(true);
  };

  const goToChannel = (): void => {
    // Событие ДО перехода: `openLink` уводит игрока из мини-аппа,
    // и отправку после него клиент может уже не успеть выполнить
    track(EVENT.subscribeClicked);
    if (channelUrl) openLink(channelUrl);
    close();
  };

  return (
    <div className={styles.sheet} data-testid="subscribe-modal">
      <div className={styles.shapeBg}>
        <img className={styles.shapeBgImage} src="/images/subscribe/shape-bg.svg" alt="" aria-hidden />
      </div>

      <button type="button" className={styles.close} aria-label="Закрыть" onClick={close}>
        <img className={styles.closeIcon} src="/images/matches/close-light.svg" alt="" aria-hidden />
      </button>

      <div className={styles.attention}>
        <img className={styles.attentionImage} src="/images/subscribe/attention.png" alt="" aria-hidden />
      </div>

      <div className={styles.content}>
        <div className={styles.text}>
          <h2 className={styles.title}>Подпишись на канал</h2>
          <p className={styles.body}>
            Это нужно, чтобы участвовать
            <br />в розыгрышах и получать призы
          </p>
        </div>

        {channelUrl ? (
          <Squircle asChild cornerRadius={RADIUS.xl}>
            <button
              type="button"
              className={styles.cta}
              onClick={goToChannel}
              data-testid="subscribe-modal-cta"
            >
              Перейти в канал
            </button>
          </Squircle>
        ) : null}
      </div>
    </div>
  );
}
